import { useParams } from "react-router-dom";
import { WorkPaperTemplateEditor } from "../../components/workPaperBuilder/WorkPaperTemplateEditor";
import { LoadingSpinner } from "../../components/ui/loadingSpinner/loadingSpinner";
import { useFeatureFlagsReady } from "../../contexts/launchDarklyContext";

export function WorkPaperTemplateEditorPage() {
  const { templateId } = useParams<{ templateId: string }>();
  // The Work Steps flag reads false until LaunchDarkly identifies the
  // workspace, and the editor seeds a new template's type from it once.
  const flagsReady = useFeatureFlagsReady();

  return (
    <div className="h-screen flex flex-col w-full mx-auto overflow-y-auto">
      <div className="px-4 mx-auto flex flex-col w-full max-w-6xl mt-16 mb-8">
        {flagsReady ? (
          <WorkPaperTemplateEditor
            templateId={templateId === "new" ? null : templateId}
          />
        ) : (
          <div className="flex items-center justify-center h-64 w-full">
            <LoadingSpinner />
          </div>
        )}
      </div>
    </div>
  );
}
